import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { clearAccessSelection } from '../store/userReducer';
import { useRole } from '../utils/RoleContext';
import { useClinic } from '../utils/ClinicContext';
import SignOutRedirect from './SignOutRedirect';

function MedicalAccessDenied() {
    const { t } = useTranslation('medicalAccess', { useSuspense: false });
    const dispatch = useDispatch();
    const { setRole } = useRole();
    const { setClinic } = useClinic();
    const [endingSession, setEndingSession] = useState(false);

    useEffect(() => {
        dispatch(clearAccessSelection());
        setRole(null);
        setClinic(null);
        sessionStorage.removeItem('role');
        sessionStorage.removeItem('clinic');
    }, [dispatch, setClinic, setRole]);

    if (endingSession) return <SignOutRedirect />;

    return (
        <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 2 }}>
            <Card variant="outlined" sx={{ width: '100%', maxWidth: 600 }}>
                <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
                    <Typography variant="h2" component="h1" sx={{ mb: 2 }}>
                        {t('title', { defaultValue: 'Acesso à plataforma médica' })}
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {t('description', {
                            defaultValue:
                                'Esta conta não tem um perfil com acesso a este portal.'
                        })}
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 3 }}>
                        {t('guidance', {
                            defaultValue:
                                'Para administrar a plataforma ou gerir a sua clínica, utilize a respetiva plataforma de gestão.'
                        })}
                    </Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => setEndingSession(true)}
                    >
                        {t('signOut', { defaultValue: 'Terminar sessão' })}
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
}

export default MedicalAccessDenied;
